  <template>
  <v-container>
    <div class="mt-4">
      <h1 class="text-center">Mot de passe oublié/Finaliser mon inscription</h1>
      <div class="d-flex">
        <v-spacer />
        <v-form ref="form" class="login">
          <v-fade-transition mode="out-in">
            <div v-if="formulaire">
              <v-card-text>
                <p>
                  Veuillez saisir votre identifiant, un courriel contenant un lien vous sera envoyé.
                </p>
                <a-login-utilisateur-row v-model="info" />
              </v-card-text>
               <v-card-text>
                <p>Veuillez prouver que vous n'êtes pas un robot.</p>
                <a-captcha-sheet v-model="captcha" service="oauth2" />
              </v-card-text>
              <v-card-text class="d-flex">
                <router-link to="/accueil">Annuler</router-link>
                <v-spacer />
                <v-btn data-testid="envoyer" @click="envoyer" :loading="working" color="primary">
                  Envoyer
                </v-btn>
              </v-card-text>
            </div>
            <div v-else>
              <v-card-text>
                <p>
                Un courriel a été envoyé à l'adresse saisie, veuillez le consulter pour terminer la procédure.
                </p>
              </v-card-text>
            </div>
          </v-fade-transition>
        </v-form>
        <v-spacer />
      </div>
    </div>
  </v-container>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import { utilisateurCycleService } from "@/services";
export default {
  mixins: [makeRemoteWorker()],
  data() {
    return {
      info: {
        login: "",
      },
       captcha: {},
      formulaire: true,
    };
  },
  methods: {
    envoyer() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return utilisateurCycleService.demandeOubli(this.info.login, this.captcha);
        },
        callback() {
          this.formulaire = false;
        },
        successText:
          "La demande a été soumise.",
        errorText: "Erreur durant la soumission",
      });
    },
  },
};
</script>
